module.exports = __webpack_public_path__ + "static/img/42576-05.eb2b2bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/42576-05.jpg
// module id = 7tEn
// module chunks = 0